import { createApiConstants } from '@saucelabs/sl-util-redux';


export const NAMESPACE = 'jobs';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const TEAMLIST_GET = createApiNamespacedConstants('TEAMLIST_GET');
export const GET_ORG_USERS = createApiNamespacedConstants('GET_ORG_USERS');
export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const CLEAR_RDC_OFFSET = `${NAMESPACE}/CLEAR_RDC_OFFSET`;
export const DECREASE_RDC_OFFSET = `${NAMESPACE}/DECREASE_RDC_OFFSET`;
export const INCREASE_RDC_OFFSET = `${NAMESPACE}/INCREASE_RDC_OFFSET`;
export const SET_CLOUD_TYPE = `${NAMESPACE}/SET_CLOUD_TYPE`;
export const INITIALIZE_FILTERS = `${NAMESPACE}/INITIALIZE_FILTERS`;
